import './ProgressTracker.scss';

import React from 'react';

import {
  AAMBeaconControl,
  AAMBeaconControlGroup
} from 'components/shared/Beacon';

const ProgressTracker = ({ name, steps, activeStep }) => {
  // activeIndex takes in generic step and needs id, name, label
  let activeIndex = steps.findIndex((step) => {
    if (activeStep) {
      return (
        step.id === activeStep?.id ||
        step.name === activeStep?.name ||
        step.label === activeStep?.label
      );
    }
    return false;
  });
  if (activeIndex === -1) {
    activeIndex = 0;
  }
  return (
    <div className="progress-tracker beacon-on-light">
      <AAMBeaconControlGroup>
        {steps.map((step, i) => (
          <div
            className={`progress-step ${i === activeIndex ? 'active' : ''}`}
            key={i}>
            <AAMBeaconControl inline>
              <label slot="label" htmlFor={`${name}-progress-${i}`}>{step.label}</label>
              <input type="radio" checked={i === activeIndex} id={`${name}-progress-${i}`}/>
            </AAMBeaconControl>
            {i !== steps.length - 1 && <div className={'progress-line'}></div>}
          </div>
        ))}
      </AAMBeaconControlGroup>
    </div>
  );
};

export default ProgressTracker;
